// Uses fetch with keepalive so the request survives component unmount.
export function fireAndForgetPost(url, body) {
  const token = localStorage.getItem('token');
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
    keepalive: true,
  });
}
